import type {FieldValues, UseFormReturn} from 'react-hook-form';

/**
 * Makes a record read again the form's baseline before the editor adopts its version: fields the
 * author has not changed take the record's values, the changed ones keep the author's. A save then
 * writes that version over what the author saw, not over another author's change the form hid.
 * `keepDirty` keeps `isDirty`, which a reset would clear while the author's changes stay.
 */
export const rebaseForm = <T extends FieldValues>(
  form: Pick<UseFormReturn<T>, 'reset'>,
  record: T
) => form.reset(record, {keepDirtyValues: true, keepDirty: true});
